import { IFundDataModel } from './fund.data-model';
import { IViewConfig2 } from './view.data-model';

type UUID = string;
export type ViewSectionUuid = UUID;
export type ViewComponentUuid = UUID;
export type ViewSections = Record<ViewSectionUuid, ViewSection>;
export enum VIEW_SECTION_TYPE {
  KPI = 'kpi',
  CHART = 'chart',
  TABLE = 'table',
}

// overlaps with COMPANY_VIEW_TYPE
export enum ViewTypeByData {
  company = 'company',
  fund = 'fund',
  multiperiod = 'multiperiod',
  people = 'people',
  security = 'security',
  transaction = 'transaction',
}

export enum VIEW_TYPE {
  COMPANY = 'company', // default view
  PERSONAL = 'personal',
  SHARED = 'shared',
}

export enum COMPANY_VIEW_TYPE {
  PORTFOLIO_OVERVIEW = 'PORTFOLIO_OVERVIEW',
  RETURN_FORECAST = 'RETURN_FORECAST',
  RETURN_FORECAST_2 = 'RETURN_FORECAST_2',
  ROUND_TRACKER = 'ROUND_TRACKER',
}

export interface ViewSection {
  id: UUID;
  type: VIEW_SECTION_TYPE;
  title: string;
}

export interface ViewOrder {
  sections: ViewSectionUuid[];
  components: Record<ViewSectionUuid, ViewComponentUuid[]>;
}

export type OriginViewDataModel = {
  companyViewType: COMPANY_VIEW_TYPE;
  createdBy: string;
  filteredFunds: IFundDataModel[] | null;
  id: number;
  isDefault: boolean;
  viewType: ViewTypeByData;
  label: string;
  name: string;
  order: ViewOrder;
  origin: null | OriginViewDataModel; // null for VIEW_TYPE.COMPANY, View for personal/custom views  used for resetting
  sections: ViewSections;
  sharing?: string[];
  type: VIEW_TYPE;
  viewId: string;
} & IViewConfig2;

export interface ViewConfigDataModel extends IViewConfig2 {
  asOfDate?: null;
  companyViewType: COMPANY_VIEW_TYPE;
  filteredFunds: IFundDataModel[] | null;
  includeNonParticipatingRounds?: boolean;
  /** Round Tracker: one row per fund in each round instead of one row per round. */
  showFundRows?: boolean;
  columnsToShow?: string[];
  isDefault: boolean;
  order: ViewOrder;
  origin: OriginViewDataModel | null;
  sections: ViewSections;
}

export function createViewConfigDataModel(overrides: Partial<ViewConfigDataModel> = {}): ViewConfigDataModel {
  return {
    companyViewType: COMPANY_VIEW_TYPE.PORTFOLIO_OVERVIEW,
    filteredFunds: [],
    isDefault: true,
    order: {
      sections: [],
      components: {},
    },
    origin: null,
    sections: {},
    ...overrides,
  };
}
